enum ItemsPerPage {
  TEN = 10,
  TWENTY = 20,
  FIFTY = 50,
  HUNDRED = 100,
}

export default ItemsPerPage;